import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';

import { SessionContext } from "../context/session-context";

/**
 * This script displays the list of addresses that the user can select from.
 * The user actions the display of the mapping window through the selection of an address.
 */

 var handleError = function (err) {
  console.log(err);
  return new Response(JSON.stringify({
    code: 400,
    message: 'Stupid network Error'
  }));
};

export default function AddressPanel(props) {

  //console.log("Address panel width: "+ props.width);
  const useStyles = makeStyles({
    root:{
      width: props.width,
      minWidth: props.width,
      maxWidth: 380,
      minHeight: 350
    },
    addressContainer:{
        maxWidth: 380,
        height: props.height - 30,
        overflowY: 'auto',
        marginRight: 0,
        marginTop:0,

    },
    addressItem:{
        color: '#000',
        backgroundColor: '#FFF',
        '&.MuiListItem-root.Mui-selected': {
          backgroundColor: '#C1DAE9',
        }

    },
    listItemText:{
      fontSize:12,//Insert your required size
    },
    selectButton:{
      marginTop: 20,
      backgroundColor:'#2D2F88',
      color: '#FFF',
      '&:hover': {
        color: '#F6A036',
      },
    }
});


  const classes = useStyles();
  const [sState, sDispatch] = useContext(SessionContext);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [disabled, setDisabled] = useState(true);
  const [addressList, setAddressList] = useState([]);
  
  /**
   * Display the selected address.
   * This loads the main mapping interface.
  */
  const handleListItemClick = (event, index) => {
    setSelectedIndex(index);
    if (index !== -1){
      setDisabled(false);
      const a = addressList[index];
      //console.log("a "+ JSON.stringify(a));
      const v = {'type': a.type,'x':a.x,'y': a.y };
      const add = {
        name: a.address,
        value: v
      };
      recordSelection(add);

      sDispatch({
        type: "displayAddress",
        payload: { 
          address:add,
        }
      });
    }
  };

  /**
   * Parse and display address results.
  */
 useEffect(() => {
   if (sState.addresses.length > 0){
      setAddressList(sState.addresses);
   } 
  },[sState.addresses]);


  /**
   * Record the selection of the address into the database.
   * Activates on aState.address change.
   */
  const recordSelection = (address) => {

      const abortController = new AbortController();
      const request = {
        ident:sState.ident,
        userid:sState.userid,
        type: address.value.type,
        search: address.name
      };
  
      let mounted = true;
      (async () => {
  
        const res = await fetch(process.env.REACT_APP_FIND_API+'/search/record', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify(request),
          signal: abortController.signal,
        }).catch(handleError);
        const data = await res.json();
        if (mounted) {
          //Do nothing.
        }
        const cleanup = () => {
          mounted = false;
          abortController.abort();
        };
        return cleanup;
    })();
  };



  return (
    <div className={classes.root}>
      <div className={classes.addressContainer}>
      <List component="nav" aria-label="Addresses returned">
            {addressList.map((item, i) => (
              <React.Fragment key={i}> 
                <ListItem 
                    key={i}
                    button
                    className={classes.addressItem}
                    selected={selectedIndex === item.key}
                    onClick={(event) => handleListItemClick(event, item.key)}
                    >
                    <ListItemText primary={item.address} classes={{primary:classes.listItemText}}/>
                </ListItem>
                <Divider />
              </React.Fragment>
            ))}
      </List>
      </div>

    </div> 
  );
}